/**
 * @deprecated Deprecated in favour of URLSearchParams
 * const params = new URLSearchParams()
 * params.append('foo[]', 'b a r') // spaces can be encoded as +
 * params.append('foo[]', 'baz') // multiple params can be added with the same name
 * -> foo[]=b+a+r&foo=baz
 *
 * This is not possible with stringifyQuery
 */
const stringifyQuery = (query: {
  // eslint-disable-next-line @typescript-eslint/ban-types
  [s: string]: string | number | object | null | undefined
}): string =>
  Object.keys(query)
    .map((key) => {
      let value = query[key]
      if (value === undefined) {
        return undefined
      }
      if (value === null) {
        return key
      }

      if (typeof value === 'object') {
        value = JSON.stringify(value)
      }

      return `${key}=${encodeURIComponent(value.toString())}`
    })
    .filter((item) => item !== undefined)
    .join('&')

export default stringifyQuery
